import { ChangeDetectionStrategy, Component, computed, effect, inject, Signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ErrorComponent } from 'error-ui';
import { TextInputComponent } from 'forms-ui';
import { ProductCrossReferencesComponentStore2 } from 'products-data';
import { EntryStatus } from 'state-data';
import { ProductComponentBase } from '../../../ProductComponentBase';
import { JsonPipe } from '@angular/common';

@Component({
  selector: 'ideal-product-cross-references',
  imports: [TextInputComponent, ReactiveFormsModule, ErrorComponent, JsonPipe],
  standalone: true,
  templateUrl: './product-cross-references.component.html',
  styleUrls: ['./product-cross-references.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ProductCrossReferencesComponentStore2],
  host: {
    '[class.loading]': 'loading()',
    '[class.no-content]': '!hasContent()',
  },
})
export class ProductCrossReferencesComponent extends ProductComponentBase {
  private readonly _crossReferencesStore = inject(ProductCrossReferencesComponentStore2);
  protected readonly crossReferences = this._crossReferencesStore.crossReferences;
  protected readonly crossReferencesLoading = this.crossReferences.loading;
  protected readonly crossReferencesError = this.crossReferences.error;
  protected readonly crossReferencesForm = this._crossReferencesStore.form;
  protected readonly hasCrossReferences = this._crossReferencesStore.hasCrossReferences;

  protected override computeIsLoading = () => computed(() => this.hasCrossReferences() && this.crossReferencesLoading());
  protected override computeHasContent = () => computed(() => this.hasCrossReferences() || !!this.crossReferencesError());

  protected readonly ready = computed(() => !this.crossReferencesError() && !this.crossReferencesLoading() && this.hasCrossReferences());

  protected entryStatusFor(customerNumber: string): Signal<EntryStatus> {
    return this._crossReferencesStore.entryStatusFor(customerNumber);
  }

  constructor() {
    super();
    effect(() => this._crossReferencesStore.setSelectedProductId(this.productId()));
  }
}
